// extracted by mini-css-extract-plugin
module.exports = {"media":"media_media__KHg5t"};